import { useTranslation } from 'react-i18next';
import { AccordionDetails } from '@mui/material';
import React from 'react';
import { OrderData } from '../../../../../api';
import { Accordion, AccordionSummary } from '../Accordion';
import { EditOrderPanels } from '../../EditOrderDialog';
import { PaymentLinksFields } from './PaymentLinksFields';

type PaymentLinksPanelProps = {
  expanded?: EditOrderPanels;
  handleChange: any;
  // Set when the dialog edits an existing pending order: the panel then edits the hold on that
  // order instead of offering to create a payment link.
  pendingOrder?: OrderData;
  // Set when a gift card covers only part of the price: the rest can only be collected with a link.
  voucherRemainderAmount?: number;
};

export const PaymentLinksPanel = ({
  expanded,
  handleChange,
  pendingOrder,
  voucherRemainderAmount,
}: PaymentLinksPanelProps) => {
  const { t } = useTranslation();

  return (
    <Accordion
      onChange={handleChange}
      panelName={EditOrderPanels.PaymentLinksPanel}
      expandedPanelName={expanded}
      allOpenValue={EditOrderPanels.AllOpen}>
      <AccordionSummary
        title={t(pendingOrder ? 'calendar.edit_order.pendingHoldPanel' : 'calendar.edit_order.paymentLinks')}
      />
      <AccordionDetails>
        <PaymentLinksFields pendingOrder={pendingOrder} voucherRemainderAmount={voucherRemainderAmount} />
      </AccordionDetails>
    </Accordion>
  );
};
